import {config} from '@/config'

const initialMessage = () => ({
    text: null,
    status: 'info',
    code: null,
	isPermanent: false,
})

export default {
    state: {
        message: initialMessage(),

        timerId: null,
		messageVisible: false,
		
    },
    
    getters: {
        messageText: state => {
            const msgText = state.message.code && config.MESSAGES[state.message.code] || state.message.text
            return msgText
        }
    },

    actions: {
        showMessage({commit, dispatch, state}, message) {
            
            if (message.text || message.code) {
                commit('SET_MESSAGE', message)
                state.messageVisible = true;

                if (state.timerId) {
                    clearTimeout(state.timerId)
                }

                if (message.status !== 'error') {
                    state.timerId = setTimeout(() => {
                        dispatch('hideMessage')
                    }, 1000)
                } else {
                    //state.message.isPermanent = true
                    state.timerId = setTimeout(() => {
                        dispatch('hideMessage')
                    }, 5000)
				}
            }
        },

        hideMessage({commit, state}) {
            commit('CLEAR_MESSAGE')
            state.messageVisible = false
            if (state.timerId) {
                clearTimeout(state.timerId)
            }
        }
    },

    mutations: {
        SET_MESSAGE(state, payload) {
            state.message = payload
        },

        CLEAR_MESSAGE(state) {
            state.message = initialMessage()
        }
    }
}